module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/K8U1SI/tc-custom/9781613123577.jpg?1718106503990",
      "alt": "This image is the cover for the book Fifty More Places to Fly Fish Before You Die, Fifty Places"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Fifty More Places to Fly Fish Before You Die, Fifty Places\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Fifty More Places to Fly Fish Before You Die is the latest offering in the bestselling Fifty Places series. Chris Santella’s first book, Fifty Places to Fly Fish Before You Die, has more than 100,000 copies in print, and Santella—now a regular fly-fishing contributor to the New York Times and many angling periodicals—has finally returned to the subject that started it all. Santella profiles 50 more first-class fly-fishing destinations around the world, as shared by top fishing-expedition leaders and journalists. This volume includes many of fly fishing’s “next big things”: fishing in San Diego for mako sharks; sight-casting in Bolivia for golden dorado; flats-style striper fishing in Maine’s Casco Bay; nocturnal sea trout angling in Wales; and fishing for giant mahseer in the Himalayan foothills of India. Gorgeous photography showcases the beauty of these destinations, and the “If You Go” section enables readers to embark on the fishing trips themselves.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Chris Santella\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Chris Santella is a freelance writer and marketing consultant. A regular contributor to the New York Times and Forbes.com, he has also contributed to the New Yorker, Travel & Leisure, and Golf, among many other publications. Santella is the author of seven other titles in the Fifty Places series (all published by Stewart, Tabori & Chang), as well as Fifty Favorite Fly-Fishing Tales. He lives in Portland, Oregon.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Abrams\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c3ee598","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0